import { Card, Typography } from '@chilecompra/react-kit/components'

import { Container } from '../Cfmp.styles'

/**
 * The CfmpInfoPanel component.
 */
export const CfmpInfoPanel = () => (
  <Card padding="24px">
    <Container direction="column" spacing={2}>
      <Typography fontWeight="bold" variant="body1">
        Compras que no aplican en este módulo
      </Typography>

      <Typography variant="body2">
        Convenios de colaboración entre organismos públicos: no constituyen procesos de compra y no
        están sujetos a la Ley de Compras.
      </Typography>

      <Typography variant="body2">
        Fondos fijos / Caja chica: corresponden a gastos menores internos definidos por normas
        administrativas del organismo.
      </Typography>

      <Typography variant="body2">
        Arriendo de inmuebles: se rige por los procedimientos regulares y la normativa específica
        asociada al arriendo de bienes raíces.
      </Typography>

      <Typography variant="body2">
        Servicios básicos: son prestaciones monopólicas que no se encuentran bajo el régimen de la
        Ley de Compras.
      </Typography>
    </Container>
  </Card>
)
